import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10" />
    <path
      fill="#fff"
      d="m9.275 15.937 2.8-2.8 2.815 2.813a.74.74 0 1 0 1.047-1.047l-2.814-2.814 2.827-2.826a.74.74 0 1 0-1.047-1.047l-2.827 2.826L9.262 8.23a.74.74 0 0 0-1.047 1.047l2.814 2.813-2.8 2.801a.74.74 0 0 0 1.046 1.047"
    />
  </svg>
);
export const CancelFullIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
